export const LOADING_REPORT = "LOADING_REPORT";
export const GET_SALESREPORT = "GET_SALESREPORT";
export const GET_FINISHED = "GET_FINISHED";
export const GET_SEMI_FINISHED = "GET__SEMI_FINISHED";
export const GET_RAW = "GET_RAW";
export const GET_COST = "GET_COST";
export const GET_PRODUCTION = "GET_PRODUCTION";
export const GET_LEADTIME = "GET_LEADTIME";
export const GET_LEAD_CONVERSION = "GET_LEAD_CONVERSION";
export const GET_BALANCESHEET_REPORT = "GET_BALANCESHEET_REPORT";
export const GET_PROFIT_AND_LOSS_REPORT = "GET_PROFIT_AND_LOSS_REPORT";
export const GET_TRIAL_BALANCE_REPORT = "GET_TRIAL_BALANCE_REPORT";
export const GET_TDS_REPORT = "GET_TDS_REPORT";
export const GET_VATRETURN_REPORT = "GET_VATRETURN_REPORT";
export const GET_PAYROLL_VARIANCE_REPORT = "GET_PAYROLL_VARIANCE_REPORT";


export const GET_CASHBOOK_REPORT = "GET_CASHBOOK_REPORT";
export const GET_GENERALLEDGER_REPORT = "GET_GENERALLEDGER_REPORT";

export const GET_COMPLAINT_RESOLUTION_TIME_REPORT = "GET_COMPLAINT_RESOLUTION_TIME_REPORT";
export const GET_STAFF_COMPLAINT_HANDLING_PERFORMANCE = "GET_STAFF_COMPLAINT_HANDLING_PERFORMANCE";
export const GET_CUSTOMER_COMPLAINT_FREQUENCY = "GET_CUSTOMER_COMPLAINT_FREQUENCY";
export const GET_LEAD_CLIENT_OPPORTUNITY_COST_SUMMARY = "GET_LEAD_CLIENT_OPPORTUNITY_COST_SUMMARY";
export const GET_CUSTOMER_TICKET_VOLUME_ANALYSIS = "GET_CUSTOMER_TICKET_VOLUME_ANALYSIS";
export const GET_SALES_SUMMARY_REPORT = "GET_SALES_SUMMARY_REPORT";
export const GET_Sales_Value_Contribution_by_Salesperson = "GET_Sales_Value_Contribution_by_Salesperson";
export const GET_Lead_Aging_Analysis = "GET_Lead_Aging_Analysis";
export const GET_SALES_ANALYTICS_REPORT = "GET_SALES_ANALYTICS_REPORT";
export const GET_SALES_ANALYTICS_REPORT_BY_PRODUCT = "GET_SALES_ANALYTICS_REPORT_BY_PRODUCT";
export const GET_SALES_ANALYTICS_REPORT_BY_CLIENT = "GET_SALES_ANALYTICS_REPORT_BY_CLIENT";
export const GET_TICKET_CATEGORY_REPORT = "GET_TICKET_CATEGORY_REPORT";
export const GET_QUOTATION_PRIORITY_REPORT = "GET_QUOTATION_PRIORITY_REPORT";
export const GET_PRODUCTION_COST_ANALYSIS_REPORT = "GET_PRODUCTION_COST_ANALYSIS_REPORT";
export const GET_PRODUCTION_REPORT = "GET_PRODUCTION_REPORT";
export const GET_PRODUCTION_LEAD_TIME_ANALYSIS_REPORT = "GET_PRODUCTION_LEAD_TIME_ANALYSIS_REPORT";
export const GET_PROJECT_COST_ANALYSIS_REPORT = "GET_PROJECT_COST_ANALYSIS_REPORT";
export const GET_PROJECT_STATUS_REPORT = "GET_PROJECT_STATUS_REPORT";
export const GET_INVENTORY_VALUE_ANALYSIS_REPORT = "GET_INVENTORY_VALUE_ANALYSIS_REPORT";
export const GET_INVENTORY_QTY_ANALYSIS_REPORT = "GET_INVENTORY_QTY_ANALYSIS_REPORT";
export const GET_WAREHOUSE_DISTRIBUTION_REPORT = "GET_WAREHOUSE_DISTRIBUTION_REPORT";
export const GET_MONTHLY_SPENDING_BY_PLATFORM = "GET_MONTHLY_SPENDING_BY_PLATFORM";
